import { EPlatformNoticeAudienceType } from "../../Enum/EPlatformNoticeAudienceType"
import { EPlatformNoticeCategoryType } from "../../Enum/EPlatformNoticeCategoryType"
import { EPlatformNoticePriorityType } from "../../Enum/EPlatformNoticePriorityType"

export class PlatformNotice {
  id: number

  title: string

  message: string

  categoryType: EPlatformNoticeCategoryType

  priorityType: EPlatformNoticePriorityType

  audienceType: EPlatformNoticeAudienceType

  isActive: boolean

  publishAtUtc: Date

  expiresAtUtc?: Date

  createdAtUtc: Date

  updatedAtUtc: Date

  targetCount: number

  readCount: number

  targetUserIds: string[]

  isRead: boolean

  readAtUtc?: Date

  constructor(data: Partial<PlatformNotice> = {}) {
    this.id = data.id ?? 0

    this.title = data.title ?? ""

    this.message = data.message ?? ""

    this.categoryType = data.categoryType ?? EPlatformNoticeCategoryType.General

    this.priorityType = data.priorityType ?? EPlatformNoticePriorityType.Normal

    this.audienceType = data.audienceType ?? EPlatformNoticeAudienceType.AllRestaurants

    this.isActive = data.isActive ?? true

    this.publishAtUtc = data.publishAtUtc ? new Date(data.publishAtUtc) : new Date()

    this.expiresAtUtc = data.expiresAtUtc ? new Date(data.expiresAtUtc) : undefined

    this.createdAtUtc = data.createdAtUtc ? new Date(data.createdAtUtc) : new Date()

    this.updatedAtUtc = data.updatedAtUtc ? new Date(data.updatedAtUtc) : new Date()

    this.targetCount = data.targetCount ?? 0

    this.readCount = data.readCount ?? 0

    this.targetUserIds = data.targetUserIds ?? []

    this.isRead = data.isRead ?? false

    this.readAtUtc = data.readAtUtc ? new Date(data.readAtUtc) : undefined
  }
}
